"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BANKING_ACCOUNT_TYPES = exports.ACCOUNT_TYPES = void 0;
exports.ACCOUNT_TYPES = {
    CASH: 'CASH',
    BANK: 'BANK',
    CREDIT: 'CREDIT',
    GOAL: 'GOAL',
    INVESTMENT: 'INVESTMENT',
    LOAN: 'LOAN',
};
exports.BANKING_ACCOUNT_TYPES = [
    'OTHER_ASSET', 'BANK', 'CREDIT', 'LOAN', 'CASH', 'OTHER_LIABILITY', 'REAL_ESTATE', 'VEHICLE',
];
